import { LocaleBundle } from "../types";

const it: LocaleBundle = {
  "ui": {
    "nav": {
      "features": "Funzionalità",
      "pricing": "Prezzi",
      "integrations": "Integrazioni",
      "industries": "Settori",
      "apiDocs": "Documentazione",
      "about": "Chi siamo",
      "customers": "Clienti",
      "contact": "Contatti",
      "login": "Accedi",
      "getFreeCRM": "Ottieni FreeCRM",
      "openMenu": "Apri menu",
      "language": "Lingua"
    },
    "hero": {
      "badge": "Il CRM multicanale: email, voce e SMS",
      "titleStart": "Il CRM creato per ",
      "titleHighlight": "team di vendita multicanale",
      "subtitle": "Raggiungi ogni cliente ovunque si trovi — con marketing via email, voce e SMS integrati in un'unica piattaforma. Nessun componente aggiuntivo, nessun costo aziendale esorbitante.",
      "cta": "Inizia gratuitamente — non è richiesta la carta",
      "pills": [
        "Email marketing",
        "Voce e chiamate",
        "SMS bidirezionali"
      ],
      "iosApp": "App iOS",
      "androidApp": "App Android",
      "heroAlt": "Dashboard di FreeCRM che mostra il pipeline delle trattative e la gestione dei contatti"
    },
    "logos": {
      "trustedBy": "Scelto da oltre 25.000 team in crescita"
    },
    "features": {
      "eyebrow": "Funzionalità",
      "title": "Unico CRM. Ogni canale utilizzato dai tuoi clienti.",
      "subtitle": "Email marketing, voce e SMS in un'unica piattaforma — così il tuo team può raggiungere i potenziali clienti come preferiscono.",
      "items": [
        {
          "title": "Email marketing",
          "desc": "Progetta campagne, invia comunicazioni e coltiva lead con sequenze — tutto dalla stessa scheda del contatto."
        },
        {
          "title": "Voce e chiamate",
          "desc": "Click-to-call, registrazione delle chiamate e registrazione integrate. Le chiamate in arrivo sono incluse con segreteria telefonica programmabile — collega il tuo numero e inizia a conversare all'istante."
        },
        {
          "title": "SMS bidirezionali",
          "desc": "Invia messaggi a lead e clienti dalla stessa casella di posta. Include modelli, invii programmati e cronologia completa delle conversazioni."
        },
        {
          "title": "Sequenze multicanale",
          "desc": "Combina email, SMS e chiamate in un'unica cadenza. Raggiungi ogni potenziale cliente sul canale a cui risponde effettivamente."
        },
        {
          "title": "Analisi unificate",
          "desc": "Traccia aperture, clic, risposte, connessioni e conversioni su ogni canale in un'unica dashboard."
        },
        {
          "title": "Automazione",
          "desc": "Iscrivi automaticamente i lead alle campagne, ruotali tra i rappresentanti e attiva i follow-up in base a qualsiasi segnale."
        },
        {
          "title": "Pianificazione riunioni",
          "desc": "Condividi link di prenotazione pubblici con più tipi di riunione. La sincronizzazione del calendario mantiene la disponibilità aggiornata e i link per le videoconferenze vengono generati automaticamente per ogni riunione."
        },
        {
          "title": "Integrazioni",
          "desc": "Collega Google, Microsoft 365, DocuSign, QuickBooks, Zapier e le videoconferenze con Zoom, Google Meet e Zoho Meeting per mantenere i dati sincronizzati e automatizzare i flussi di lavoro negli strumenti che già usi."
        },
        {
          "title": "CRM assistito dall'IA",
          "desc": "Lascia che l'IA rediga le risposte alle email, suggerisca i prossimi passi, riassuma le conversazioni e mantenga ogni trattativa in movimento — così il team scrive meno e vende di più."
        }
      ]
    },
    "testimonials": {
      "eyebrow": "Clienti",
      "title": "Scelto da team di vendita multicanale",
      "items": [
        {
          "quote": "Abbiamo sostituito tre strumenti — email marketing, dialer e CRM — con FreeCRM. Il nostro team ora gestisce campagne via email, SMS e chiamate da un unico posto.",
          "name": "Maya Chen",
          "role": "Vicepresidente Vendite, SaaS B2B"
        },
        {
          "quote": "Le sequenze multicanale hanno cambiato tutto. Mixare email, SMS e una chiamata in un'unica cadenza ha raddoppiato il nostro tasso di risposta senza aumentare il personale.",
          "name": "Daniel Okafor",
          "role": "Direttore Vendite, Apex Solutions"
        },
        {
          "quote": "Siamo passati da HubSpot a FreeCRM e finalmente abbiamo avuto email marketing, voce e SMS in un'unica piattaforma — senza costi di integrazione.",
          "name": "Priya Raman",
          "role": "COO, Brightline"
        }
      ]
    },
    "pricing": {
      "eyebrow": "Prezzi",
      "title": "Prezzi del software CRM",
      "subtitle": "Numeri di telefono USA solo $1.15/mese · $0.01 al minuto · $0.01 per SMS",
      "mostPopular": "Più popolare",
      "perUserMo": "/utente/mese",
      "tiers": [
        {
          "name": "Free",
          "price": "$0",
          "blurb": "Gratuito per sempre con email, voce e SMS integrati.",
          "cta": "Iscriviti gratuitamente"
        },
        {
          "name": "Pro",
          "price": "$10",
          "blurb": "Tutta la potenza del CRM per i team di vendita in crescita.",
          "cta": "Iscriviti"
        },
        {
          "name": "Enterprise",
          "price": "$25",
          "blurb": "Funzionalità avanzate per team ad alto volume.",
          "cta": "Iscriviti"
        }
      ],
      "sharedFeatures": [
        "Archiviazione illimitata",
        "Contatti e aziende",
        "Affari e attività",
        "Casi e chiamate",
        "Calendario e documenti",
        "Report",
        "App iOS e Android",
        "Campagne e moduli",
        "Email",
        "Accesso API",
        "Google Sync",
        "QuickBooks",
        "SMS",
        "Chiamate vocali",
        "Carta di credito"
      ]
    },
    "faq": {
      "eyebrow": "FAQ",
      "title": "Domande, risposte",
      "items": [
        {
          "q": "FreeCRM è veramente gratuito per email, voce e SMS?",
          "a": "Sì — il piano Free include email marketing, click-to-call, registrazione delle chiamate e 500 messaggi SMS al mese senza costi. I piani a pagamento sbloccano limiti di invio maggiori, automazioni avanzate, registrazione delle chiamate e SMS illimitati."
        },
        {
          "q": "In cosa FreeCRM si differenzia da HubSpot?",
          "a": "A differenza di HubSpot, ogni canale è nativo — email marketing, voce e SMS sono tutti inclusi, non venduti come componenti aggiuntivi separati o integrazioni costose."
        },
        {
          "q": "Posso eseguire campagne e sequenze email?",
          "a": "Sì. Progetta broadcast, campagne drip e sequenze multi-step che combinano email, SMS e chiamate — con tracciamento completo di aperture, clic e risposte."
        },
        {
          "q": "Come funziona la telefonia in FreeCRM?",
          "a": "Le chiamate avvengono direttamente nel tuo browser — nessun dialer o telefono separato richiesto. Effettua chiamate in uscita con il click-to-call, ricevi chiamate in entrata sul tuo numero FreeCRM e instradale verso il giusto rappresentante. La segreteria telefonica programmabile con saluti personalizzati e trascrizione automatica cattura ogni chiamata persa."
        },
        {
          "q": "Supportate gli SMS bidirezionali?",
          "a": "Sì. Invia e ricevi SMS dalla stessa casella di posta delle tue email, con modelli, invii programmati e cronologia completa delle conversazioni per contatto."
        }
      ]
    },
    "cta": {
      "title1": "Email, voce e SMS in un unico CRM.",
      "title2": "Raggiungi i clienti su ogni canale.",
      "subtitle": "Unisciti a oltre 25.000 team che utilizzano FreeCRM per email marketing, voce e SMS — tutto in un'unica piattaforma multicanale gratuita.",
      "button": "Inizia gratuitamente"
    },
    "footer": {
      "tagline": "Il CRM gratuito che cresce con la tua attività.",
      "copyright": "Tutti i diritti riservati.",
      "tagBuiltFor": "Ideato per i team che meritano di più di HubSpot.",
      "cols": {
        "product": "Prodotto",
        "company": "Azienda",
        "resources": "Risorse",
        "legal": "Legale"
      },
      "links": {
        "features": "Funzionalità",
        "pricing": "Prezzi",
        "integrations": "Integrazioni",
        "industries": "Settori",
        "changelog": "Changelog",
        "about": "Chi siamo",
        "customers": "Clienti",
        "careers": "Carriere",
        "contact": "Contatti",
        "blog": "Blog",
        "helpCenter": "Centro assistenza",
        "apiDocs": "Documentazione",
        "community": "Community",
        "privacy": "Privacy",
        "terms": "Termini",
        "security": "Sicurezza",
        "dpa": "DPA"
      }
    },
    "contentPage": {
      "readyToStart": "Pronto per iniziare?",
      "joinThousands": "Unisciti a migliaia di team che utilizzano FreeCRM per potenziare email marketing, voce, SMS e pipeline.",
      "defaultCta": "Inizia gratuitamente — non è richiesta la carta",
      "learnMore": "Scopri di più →"
    },
    "languageNames": {
      "en": "English",
      "es": "Español",
      "fr": "Français",
      "pt": "Português",
      "it": "Italiano", "de": "Deutsch", "ar": "العربية"
    }
  },
  "featurePages": {
    "calling": {
      "title": "Chiamate integrate",
      "eyebrow": "Funzionalità",
      "description": "Click-to-call, chiamate in arrivo con segreteria telefonica programmabile, chiamate dal browser, numeri virtuali, registrazione e power dialer — tutto integrato in FreeCRM.",
      "intro": "Le soluzioni CRM per call center di FreeCRM automatizzano le chiamate in entrata e in uscita in 90 paesi. Le chiamate in arrivo sono incluse con segreteria telefonica programmabile — ottieni un numero virtuale o usa il tuo cellulare, e inizia a chiamare da qualsiasi scheda di contatto.",
      "sections": [
        {
          "heading": "Click-to-call da ovunque",
          "body": "Scopri perché siamo il CRM gratuito n. 1 per l'automazione della forza vendita, il marketing e il servizio clienti — con chiamate click-to-call dal browser a qualsiasi numero di telefono, da qualsiasi contatto, affare o record aziendale."
        },
        {
          "heading": "Registrazione, programmazione e chiamate di gruppo",
          "body": "Registra le chiamate per coaching e conformità, programma follow-up, ospita chiamate di gruppo e invia SMS — tutto dall'interno del CRM senza strumenti aggiuntivi."
        },
        {
          "heading": "Chiamate in arrivo e segreteria programmabile",
          "body": "Ogni numero FreeCRM riceve chiamate in arrivo e in uscita — senza costi extra. Instrada le chiamate al commerciale giusto, imposta gli orari di apertura e configura una segreteria telefonica programmabile con saluti personalizzati e trascrizione automatica per non perdere mai un messaggio."
        },
        {
          "heading": "Power dialer e script di chiamata",
          "body": "Massimizza l'efficacia con clienti esistenti e potenziali. Potenti script di chiamata e automazione generano risultati di vendita affidabili, aiutandoti ad aumentare i tuoi profitti."
        },
        {
          "heading": "Campagne e follow-up",
          "body": "Crea campagne di chiamate e SMS, automatizza chiamate e SMS, e organizza e programma i tuoi follow-up in modo che nulla venga trascurato."
        }
      ]
    },
    "contacts": {
      "title": "Gestione contatti e lead",
      "eyebrow": "Funzionalità",
      "description": "Contatti illimitati, campi personalizzati e importazione potente da Outlook, Salesforce, HubSpot o Zoho.",
      "intro": "I contatti sono i tuoi potenziali clienti, lead e clienti — fornitori, partner, donatori. In FreeCRM, i tuoi contatti sono d'oro e li trattiamo così.",
      "sections": [
        {
          "heading": "Personalizza tutto",
          "body": "Aggiungi tutti i campi personalizzati di cui hai bisogno. Ogni azienda ha bisogno di un CRM personalizzato — con FreeCRM puoi personalizzare le schede dei contatti, i moduli e ogni parte del sistema."
        },
        {
          "heading": "Traccia ogni interazione",
          "body": "Traccia e gestisci relazioni, chiamate e riunioni. Associa documenti, note di riunioni e chiamate e altre informazioni importanti alle persone per cui lavori e con cui lavori."
        },
        {
          "heading": "B2B, B2C e altro",
          "body": "I contatti sono individui che possono appartenere ad aziende o altre organizzazioni. Supportiamo modelli di business B2B, B2C e più complessi."
        },
        {
          "heading": "Importa da qualsiasi luogo",
          "body": "Importa elenchi di contatti da qualsiasi file di foglio di calcolo, Outlook, Salesforce, HubSpot, Zoho o qualsiasi altro software di gestione dei contatti."
        }
      ]
    },
    "companies": {
      "title": "Aziende e account",
      "eyebrow": "Funzionalità",
      "description": "Traccia organizzazioni, fornitori e partner con campi personalizzati, elenchi e cronologia attività condivisa.",
      "intro": "L'elenco Aziende di FreeCRM fornisce un tracciamento organizzativo robusto e flessibile per qualsiasi entità — B2B, B2C, senza scopo di lucro o governativa — con campi completamente personalizzabili.",
      "sections": [
        {
          "heading": "Organizza e condividi",
          "body": "Organizza per categoria, stato, priorità o filtri personalizzati. Importa ed esporta istantaneamente elenchi, crea elenchi illimitati e condividi informazioni organizzative all'interno del tuo team."
        },
        {
          "heading": "Tutta l'attività in un unico posto",
          "body": "Chiamate di vendita, ticket di problemi e attività dei clienti vengono tracciati e riportati. Le campagne email e il tracciamento dell'automazione delle chiamate sono organizzati per azienda."
        },
        {
          "heading": "Perché le aziende?",
          "body": "Tracciando le aziende con cui fai affari, i tuoi team possono orchestrare campagne di vendita più efficaci e identificare e condividere opportunità all'interno della tua organizzazione."
        }
      ]
    },
    "deals": {
      "title": "Pipeline delle trattative",
      "eyebrow": "Funzionalità",
      "description": "Pipeline di vendita visiva, tracciamento delle fasi, previsioni e report — creato per team di vendita outbound.",
      "intro": "Le trattative sono il motivo per cui sei qui. Il set di funzionalità Dedali di FreeCRM ti consente di gestire e tracciare i lead, applicando una metodologia di vendita efficace per portare la tua attività al livello successivo.",
      "sections": [
        {
          "heading": "Tracciamento delle fasi",
          "body": "Le trattative vengono tracciate attraverso lo stato — preventivo, stima, ordine di acquisto, fattura, commissione — in modo da sapere sempre a che punto è ogni opportunità."
        },
        {
          "heading": "Report e previsioni",
          "body": "La pipeline fornisce tabelle, report e grafici che mostrano l'andamento del tuo team di vendita e delle tue campagne. Quantifica il successo nel tempo e identifica nuove opportunità all'interno di clienti nuovi o esistenti."
        },
        {
          "heading": "Collaborazione di squadra",
          "body": "Il tracciamento delle trattative conferisce coesione alle persone che supportano le tue vendite. I servizi e il supporto possono collaborare durante tutto il ciclo per dimostrare e ottenere il successo del team."
        }
      ]
    },
    "tasks": {
      "title": "Gestione attività",
      "eyebrow": "Funzionalità",
      "description": "Prioritizza, assegna e traccia le attività con flusso di lavoro e stato — attraverso trattative, contatti e casi.",
      "intro": "Tenere traccia delle attività, dei problemi e delle vendite ti offre una visibilità completa sul tempo che tu e il tuo team dedicate a ogni affare o problema.",
      "sections": [
        {
          "heading": "Assegna attività!",
          "body": "Dai priorità alle attività, crea tipi di attività personalizzati specifici per la tua attività, assegna le attività ai membri del team o ai dipendenti, assegna loro un flusso di lavoro e uno stato, e delega il carico di lavoro all'interno del tuo team."
        },
        {
          "heading": "Un delegatore migliore",
          "body": "Poiché puoi assegnare attività, diventi istantaneamente un delegatore migliore senza perdere visibilità sulla qualità e sul servizio che il tuo team offre."
        }
      ]
    },
    "cases": {
      "title": "Gestione casi",
      "eyebrow": "Funzionalità",
      "description": "Apri ticket, smista problemi, personalizza stati e priorità e risolvi ogni caso cliente.",
      "intro": "Il tracciamento dei casi e dei problemi offre una visibilità al 100% su tutte le questioni che gestisci per clienti, fornitori e partner.",
      "sections": [
        {
          "heading": "Help desk virtuale",
          "body": "Avvia un nuovo caso e apri un ticket nel tuo help desk virtuale. Associa casi a lungo termine a problemi in corso che possono essere rapidamente risolti e chiusi."
        },
        {
          "heading": "Personalizza per il tuo team",
          "body": "Personalizza i problemi di supporto con campi personalizzati, assegna i problemi a uno o più membri del team e traccia ogni caso in modo che nessun problema del cliente venga trascurato."
        },
        {
          "heading": "Connetti tutto",
          "body": "Collega i casi ad aziende, contatti, chiamate, eventi o documenti. Aggiungi note man mano che il problema progredisce e conserva tutte le informazioni in un unico caso conveniente."
        }
      ]
    },
    "campaigns": {
      "title": "Automazione marketing",
      "eyebrow": "Funzionalità",
      "description": "Campagne email e SMS, segmentazione e automazione integrate nel tuo CRM.",
      "intro": "Crea liste di distribuzione basate su dati demografici, preferenze e interazioni. Crea ed esegui campagne email personalizzate in quattro semplici passaggi.",
      "sections": [
        {
          "heading": "Personalizzato e su vasta scala",
          "body": "Il software di email marketing CRM fa più che inviare email di massa — costruisci sequenze personalizzate, gestisci liste mirate e segui automaticamente."
        },
        {
          "heading": "Modelli adatti ai dispositivi mobili",
          "body": "Modelli di email facilmente personalizzabili e responsive su tutti i dispositivi, inclusi telefoni cellulari, tablet e altro."
        },
        {
          "heading": "SMS + email insieme",
          "body": "Combina sequenze di email e SMS. Coinvolgi i tuoi clienti come mai prima d'ora e mantieni tutto in un unico posto."
        }
      ]
    },
    "calendar": {
      "title": "Calendario di gruppo",
      "eyebrow": "Funzionalità",
      "description": "Calendario del team condiviso con promemoria email e SMS, completamente integrato con contatti, trattative e attività.",
      "intro": "Il calendario di gruppo di FreeCRM è un ottimo modo per gestire e visualizzare il tuo programma, le attività giornaliere, settimanali e mensili del tuo team, le riunioni con i clienti e le chiamate.",
      "sections": [
        {
          "heading": "Non perdere mai un evento",
          "body": "Invia notifiche via email e SMS in modo che nessuno abbia più una scusa per perdere un evento."
        },
        {
          "heading": "Connesso a tutto",
          "body": "Traccia eventi futuri, imposta promemoria, crea attività, inserisci note, allega file e associa le voci del calendario a uno o più contatti. Assegna attività a uno o più colleghi."
        },
        {
          "heading": "Filtra per team o contatto",
          "body": "Visualizza gli eventi per l'intero database, un singolo contatto, te stesso, un collega o più membri del team. Sei sempre a un solo clic dalla cronologia o dalle informazioni di contatto."
        }
      ]
    },
    "documents": {
      "title": "Gestione documenti",
      "eyebrow": "Funzionalità",
      "description": "Archiviazione illimitata di documenti, accesso mobile e allegati di file per record.",
      "intro": "Condividi documenti importanti con il tuo team e fornisci accesso istantaneo a tutti i tuoi file elettronici. Carica un singolo file o un'intera directory con un solo clic.",
      "sections": [
        {
          "heading": "Archiviazione illimitata",
          "body": "Il nostro servizio gratuito include spazio di archiviazione illimitato per tutti i documenti importanti del tuo team. Ogni membro può avere il proprio archivio documenti e collegare file a qualsiasi record."
        },
        {
          "heading": "Mobile-first",
          "body": "Accedi ai documenti dalle nostre app iOS e Android — apri il CRM mobile, recupera un documento e invia SMS ed email ai potenziali clienti direttamente sul posto."
        },
        {
          "heading": "Centralizza le risorse",
          "body": "Un luogo sicuro e protetto per centralizzare le tue risorse documentali elettroniche. Il tuo team può accedere a contratti, letteratura di vendita e marketing, moduli standardizzati e altro da qualsiasi parte del mondo."
        }
      ]
    },
    "email": {
      "title": "Automazione email",
      "eyebrow": "Funzionalità",
      "description": "Sequenze email personalizzate, liste segmentate e targeting basato su CRM.",
      "intro": "Costruisci liste di distribuzione basate su dati demografici, preferenze e interazioni per messaggistica mirata. Risparmia tempo e aumenta la produttività del 74% con gli strumenti email giusti.",
      "sections": [
        {
          "heading": "Quattro semplici passaggi",
          "body": "Crea ed esegui campagne email personalizzate in quattro semplici passaggi con il software CRM di email marketing."
        },
        {
          "heading": "Più di un semplice invio massivo",
          "body": "Il CRM di email marketing aiuta i team con molto più che seguire i lead di vendita, inviare email di massa o creare sequenze personalizzate."
        },
        {
          "heading": "Modelli responsive",
          "body": "Modelli facilmente personalizzabili e responsive su tutti i dispositivi — telefoni, tablet e desktop."
        }
      ]
    },
    "forms": {
      "title": "Moduli e sondaggi",
      "eyebrow": "Funzionalità",
      "description": "Moduli guidati multipagina, script di chiamata e sondaggi che alimentano direttamente il CRM.",
      "intro": "I moduli sono sondaggi domanda-risposta — e possono anche essere script di chiamata che il tuo personale di vendita o supporto completa con i potenziali clienti in linea.",
      "sections": [
        {
          "heading": "Moduli guidati",
          "body": "La creazione di moduli e sondaggi è facile con il nostro costruttore di moduli, creando moduli guidati multipagina facili da seguire e completare. Una volta terminato, ti verrà fornito un link pubblico da distribuire."
        },
        {
          "heading": "Feedback dei clienti e script interni",
          "body": "Utilizza i moduli per il feedback dei clienti, questionari per il personale e script di chiamata. Costruisci sondaggi personalizzati per le vendite, il marketing e la soddisfazione del cliente."
        },
        {
          "heading": "Reporting ed esportazione",
          "body": "I risultati dei moduli web e dei sondaggi alimentano un sistema di reporting, presentato in tabelle. Esporta in Excel o CSV per analisi o importazione marketing."
        }
      ]
    }
  },
  "industryPages": {
    "callcenter": {
      "title": "FreeCRM per call center",
      "eyebrow": "Settore",
      "description": "CRM per call center con composizione, registrazione, scripting e SMS integrati in 90 paesi.",
      "intro": "Automatizza le chiamate in entrata e in uscita in 90 paesi in tutto il mondo. Ottieni un numero di telefono virtuale e configura le funzionalità del call center fin da subito.",
      "sections": [
        {
          "heading": "Tutte le tue chiamate, in un unico posto",
          "body": "Chiamate click-to-call dal browser a qualsiasi numero di telefono. Ottieni un numero virtuale o usa il tuo cellulare — FreeCRM fa tutto questo."
        },
        {
          "heading": "Registrazione e programmazione",
          "body": "Effettua registrazioni di chiamate, programma chiamate e chiamate di gruppo, e invia SMS da qualsiasi dispositivo. Funzionalità avanzate per l'automazione dei call center."
        },
        {
          "heading": "Scripting e automazione",
          "body": "Potenti script di chiamata e automazione guidano risultati di vendita affidabili. Crea script assegnati e programmati ai membri del team; traccia ogni chiamata e i suoi risultati nel nostro sistema ricco di funzionalità."
        },
        {
          "heading": "Campagne e follow-up",
          "body": "Crea campagne di chiamate e SMS, automatizzale e organizza i follow-up in modo che il tuo team non perda mai un punto di contatto."
        }
      ]
    },
    "insurance": {
      "title": "FreeCRM per il settore assicurativo",
      "eyebrow": "Settore",
      "description": "Cloud CRM assicurativo per agenti, originator e servizi per tracciare clienti, polizze e sinistri.",
      "intro": "Il CRM per il settore assicurativo aiuta agenti, originator e servizi a vendere a consumatori e aziende e a tracciare tutte le interazioni nel cloud.",
      "sections": [
        {
          "heading": "Creata per agenti e sottoscrittori",
          "body": "Che tu sia un agente, un sottoscrittore, un fornitore di servizi o un altro professionista del settore assicurativo, possiamo aiutarti con le tue esigenze CRM."
        },
        {
          "heading": "Polizze, sinistri e clienti",
          "body": "Automatizza il tracciamento di clienti importanti, polizze, sinistri e altro con modelli assicurativi pronti all'uso che funzionano per B2C e B2B."
        },
        {
          "heading": "Creata per la fidelizzazione",
          "body": "Il CRM è fondamentale nel settore assicurativo a causa dei prodotti complessi, della necessità di una comunicazione continua e dell'importanza della fidelizzazione del cliente."
        }
      ]
    },
    "realestate": {
      "title": "FreeCRM per il settore immobiliare",
      "eyebrow": "Settore",
      "description": "Gestione lead e proprietà per professionisti immobiliari residenziali e commerciali.",
      "intro": "FreeCRM è utilizzato in tutto il settore immobiliare da ogni categoria di professionisti — residenziale o commerciale, acquisto, vendita, intermediazione o gestione.",
      "sections": [
        {
          "heading": "Gestione lead e proprietà",
          "body": "Semplifica la gestione dei lead e delle proprietà nel settore residenziale e commerciale. Gli agenti adorano il nostro CRM — e lo stesso vale per gli intermediari e i gestori di proprietà."
        },
        {
          "heading": "Elenca le proprietà come trattative",
          "body": "Usa la sezione Trattative per elencare le proprietà — tipicamente per indirizzo (es. 'Via Roma 100'). Aggiungi più potenziali clienti a una singola proprietà e usa la bacheca di vendita o la pipeline per tracciare gli imbuti."
        },
        {
          "heading": "HOA e beni complessi",
          "body": "I gestori di proprietà nel settore residenziale, commerciale, multifamiliare, condominii di lusso e HOA utilizzano FreeCRM per gestire ogni aspetto delle operazioni."
        }
      ]
    },
    "dental": {
      "title": "FreeCRM per il settore dentale",
      "eyebrow": "Settore",
      "description": "CRM HIPAA-ready per dentisti, chirurghi orali e la comunità dentale specializzata.",
      "intro": "Supportiamo il settore dentale con un CRM all'avanguardia per dentisti, chirurghi orali e tutti i professionisti della comunità medica specializzata — e forniamo la certificazione BAA per la conformità HIPAA.",
      "sections": [
        {
          "heading": "Scelto da migliaia di studi",
          "body": "Con migliaia di clienti dentali, FreeCRM gestisce i requisiti di conformità per il settore dentale, la chirurgia orale, gli impianti dentali e le industrie adiacenti che gestiscono le informazioni dei pazienti."
        },
        {
          "heading": "Sicurezza dei dati",
          "body": "La sicurezza dei dati è la ragion d'essere di FreeCRM. I server sono ospitati su AWS — conformi HIPAA — e forniamo certificati BAA per gli studi che ne hanno bisogno."
        },
        {
          "heading": "Integra il tuo stack",
          "body": "Inizia rapidamente e integra con i principali sistemi di gestione dello studio e di imaging utilizzati in odontoiatria."
        }
      ]
    },
    "hipaa": {
      "title": "CRM conforme a HIPAA",
      "eyebrow": "Conformità",
      "description": "FreeCRM è conforme a HIPAA da oltre un decennio — certificati BAA disponibili con Enterprise.",
      "intro": "La gestione delle informazioni sanitarie dei pazienti è complessa. FreeCRM ha lanciato HIPAACRM.com nel 2014 — il primo CRM al mondo conforme a HIPAA — e rimane un leader in sicurezza e responsabilità.",
      "sections": [
        {
          "heading": "Hai bisogno di un BAA?",
          "body": "Se hai bisogno di un certificato Business Associate Addendum (BAA) per garantire la conformità HIPAA, possiamo aiutarti. È richiesta la nostra edizione Enterprise, pagabile annualmente per posto in anticipo ($300/utente/anno)."
        },
        {
          "heading": "Oltre gli studi medici",
          "body": "Non si tratta solo di studi medici — studi clinici, nutrizionisti, terapisti e qualsiasi attività che gestisca informazioni sanitarie approfittano del nostro supporto HIPAA."
        },
        {
          "heading": "Sicurezza all'avanguardia",
          "body": "12 anni di esperienza HIPAA, ospitato su AWS, con la sicurezza e la responsabilità di cui hai bisogno per le informazioni sanitarie protette."
        }
      ]
    },
    "insidesales": {
      "title": "FreeCRM per le vendite interne e indipendenti",
      "eyebrow": "Settore",
      "description": "Aumenta la produttività di oltre il 30% con un'automazione CRM semplice, creata per i rappresentanti interni e indipendenti.",
      "intro": "FreeCRM aiuta i rappresentanti di vendita indipendenti e i team di vendita interni ad aumentare la produttività con semplici strumenti di automazione CRM e dashboard.",
      "sections": [
        {
          "heading": "Aumento di produttività di oltre il 30%",
          "body": "I rappresentanti di vendita indipendenti possono aumentare le vendite di oltre il 30% semplicemente tracciando contatti e aziende — e i nostri strumenti di automazione amplificano l'impatto."
        },
        {
          "heading": "Traccia ogni interazione",
          "body": "Registra ogni chiamata, email e riunione. Avere una registrazione chiara di ciò che è stato detto e ciò che deve accadere dopo, prioritizzare le attività e seguire in tempo."
        },
        {
          "heading": "Adatto ai lavoratori autonomi",
          "body": "Costruito per l'autonomia dei rappresentanti indipendenti che rappresentano più aziende. Gestisci il tuo programma e le relazioni con i clienti da qualsiasi luogo."
        }
      ]
    },
    "contractor": {
      "title": "FreeCRM per appaltatori e costruttori",
      "eyebrow": "Settore",
      "description": "Gestisci offerte, subappaltatori, programmazione e avvisi in tempo reale per GC e costruttori commerciali.",
      "intro": "Appaltatori, costruttori, GC e fornitori di costruzioni commerciali utilizzano facilmente FreeCRM per gestire offerte e terze parti multiple come i subappaltatori.",
      "sections": [
        {
          "heading": "Gestione dei lead",
          "body": "Traccia i lead, monitora i progressi e dai priorità agli sforzi. Ottieni informazioni sul comportamento dei lead in modo da poter decidere quali perseguire."
        },
        {
          "heading": "Stime e proposte",
          "body": "Automatizza il processo di stima e proposta con un database centralizzato di proposte precedenti, stime e dati sui prezzi — risparmiando tempo e migliorando la precisione."
        },
        {
          "heading": "Pianificazione e avvisi",
          "body": "Assegna rapidamente team e individui con avvisi in tempo reale via email o SMS. Mantieni coordinati subappaltatori e squadre."
        }
      ]
    },
    "professional": {
      "title": "FreeCRM per i servizi professionali",
      "eyebrow": "Settore",
      "description": "Gestione clienti, conformità ed erogazione di servizi per le aziende di servizi professionali.",
      "intro": "Le aziende di servizi professionali utilizzano FreeCRM per gestire i dati dei clienti, tracciare le interazioni e fornire un servizio migliore da qualsiasi luogo, su qualsiasi dispositivo.",
      "sections": [
        {
          "heading": "Migliore soddisfazione del cliente",
          "body": "Una visione completa della relazione con il cliente — dettagli di contatto, transazioni passate, preferenze di comunicazione — porta a una maggiore soddisfazione e fedeltà."
        },
        {
          "heading": "Conformità più semplice",
          "body": "Soddisfa il GDPR e requisiti simili con una posizione centrale per archiviare e condividere la documentazione di conformità, e trasparenza sulle fonti di dati dei clienti."
        },
        {
          "heading": "Fai crescere l'azienda",
          "body": "Il CRM oggi deve essere accessibile da qualsiasi luogo, su qualsiasi dispositivo, in qualsiasi lingua — con intelligence sociale e best practice integrata per aiutarti a muoverti più velocemente."
        }
      ]
    }
  },
  "integrationPages": {
    "google": {
      "title": "FreeCRM + Google Workspace",
      "eyebrow": "Integrazione",
      "description": "Sincronizza Gmail, Google Calendar e Google Contacts con FreeCRM con un clic.",
      "intro": "Gmail e Google Workspace sono profondamente integrati con FreeCRM. Collega il tuo account Google e sincronizza email, contatti e calendario.",
      "sections": [
        {
          "heading": "Configurazione con un clic",
          "body": "È semplice aggiungere il tuo account Google — proprio come qualsiasi altra app integrata con Google, è un accesso con un clic. Puoi anche utilizzare il tuo account Google per accedere a FreeCRM."
        },
        {
          "heading": "Sincronizza ciò che vuoi",
          "body": "Una volta aggiunto Google a FreeCRM, scegli se sincronizzare l'account completo o utilizzare solo la funzionalità email integrata. Calendario e Google Contacts verranno sincronizzati quando effettui la sincronizzazione."
        },
        {
          "heading": "Workspace diventa un CRM",
          "body": "Sistemi CRM altamente integrati possono trasformare Google Workspace in un potente CRM che funziona con l'hosting aziendale di Google o qualsiasi account Gmail."
        }
      ]
    },
    "quickbooks": {
      "title": "FreeCRM + QuickBooks",
      "eyebrow": "Integrazione",
      "description": "L'integrazione CRM con QuickBooks più votata — Online e Desktop, sincronizzazione bidirezionale.",
      "intro": "La migliore integrazione QuickBooks — classificata n. 1 dai QuickBooks ProAdvisors. CRM per QuickBooks Online e Desktop semplifica le operazioni e ti aiuta ad aumentare le vendite.",
      "sections": [
        {
          "heading": "Strettamente integrato",
          "body": "Se stai cercando un'applicazione CRM strettamente integrata con QuickBooks Online, FreeCRM è la soluzione perfetta."
        },
        {
          "heading": "Centralizza i dati dei clienti",
          "body": "Un CRM che si integra con QuickBooks utilizza integrazioni software di contabilità per archiviare e centralizzare i dati dei tuoi clienti tra vendite e finanza."
        },
        {
          "heading": "Online + Desktop",
          "body": "Sono supportati sia QuickBooks Online che QuickBooks Desktop."
        }
      ]
    },
    "zapier": {
      "title": "FreeCRM + Zapier",
      "eyebrow": "Integrazione",
      "description": "Connetti FreeCRM con oltre 6.000 app su Zapier — il modo più semplice per automatizzare.",
      "intro": "Connetti istantaneamente il connettore FreeCRM con le app che usi ogni giorno. FreeCRM si integra con oltre 6.000 altre app su Zapier — il modo più semplice per automatizzare.",
      "sections": [
        {
          "heading": "Oltre 6.000 app",
          "body": "Da Slack a Stripe a Google Sheets, spingi e tira dati da FreeCRM nel resto del tuo stack senza scrivere codice."
        },
        {
          "heading": "Automazione senza codice",
          "body": "Crea Zap per registrare chiamate, creare contatti, sincronizzare affari e attivare campagne ogni volta che succede qualcosa nei tuoi altri strumenti."
        }
      ]
    },
    "docusign": {
      "title": "FreeCRM + DocuSign",
      "eyebrow": "Integrazione",
      "description": "Invia, firma e traccia accordi direttamente dal tuo CRM con l'integrazione DocuSign.",
      "intro": "DocuSign è la piattaforma leader mondiale per la firma di documenti. FreeCRM ti consente di semplificare i processi popolando i documenti con i dati del CRM e aggiornando il CRM dai campi DocuSign.",
      "sections": [
        {
          "heading": "Tracciamento in tempo reale",
          "body": "Richiedi firme e traccia lo stato dell'accordo in tempo reale. Risparmia tempo con flussi di lavoro personalizzati che attivano accordi con un clic — e riducono gli errori."
        },
        {
          "heading": "Flusso di dati bidirezionale",
          "body": "Automatizza interi flussi di lavoro, genera e invia contratti e archivia documenti completati. Aggiorna i sistemi con i dati dei documenti o popola i documenti dal CRM — funziona in entrambi i modi."
        }
      ]
    },
    "whatsapp": {
      "title": "FreeCRM + WhatsApp",
      "eyebrow": "Integrazione",
      "description": "Usa l'API di WhatsApp Business per chiamate e messaggi dall'interno di FreeCRM.",
      "intro": "WhatsApp e FreeCRM formano una potente combinazione — usa l'API di WhatsApp Business per chiamate e messaggi, e automatizza l'acquisizione e le comunicazioni dei lead.",
      "sections": [
        {
          "heading": "Comunicazione semplificata",
          "body": "Gestisci le interazioni con i clienti WhatsApp in un'unica posizione centrale per tempi di risposta più rapidi e maggiore soddisfazione."
        },
        {
          "heading": "Integrazione dati cliente",
          "body": "Porta i dati dei clienti WhatsApp in FreeCRM e automatizza attività ripetitive come l'inoltro di messaggi, la prioritizzazione delle risposte e l'immissione dei dati."
        }
      ]
    },
    "microsoft365": {
      "title": "FreeCRM + Microsoft 365",
      "eyebrow": "Integrazione",
      "description": "Sincronizza Outlook, calendario e contatti con FreeCRM utilizzando Microsoft 365.",
      "intro": "Microsoft 365 si integra con FreeCRM per sincronizzare la posta di Outlook, il calendario e i contatti in un unico posto.",
      "sections": [
        {
          "heading": "Accesso Microsoft con un clic",
          "body": "Collega il tuo account Microsoft 365 e usalo per accedere a FreeCRM, proprio come qualsiasi altra app integrata con Microsoft."
        },
        {
          "heading": "Posta, calendario e contatti",
          "body": "Scegli cosa sincronizzare: le conversazioni e-mail, gli eventi del calendario e i contatti di Outlook rimangono aggiornati tra FreeCRM e Microsoft 365."
        },
        {
          "heading": "Pronto per i team",
          "body": "Funziona con Outlook personale, Microsoft 365 Business e tenant Enterprise, in modo che tutto il team rimanga sincronizzato."
        }
      ]
    },
    "video-conferencing": {
      "title": "FreeCRM + Videoconferenze",
      "eyebrow": "Integrazione",
      "description": "Genera automaticamente link Zoom, Google Meet e Zoho Meeting per ogni riunione pianificata.",
      "intro": "La pianificazione di FreeCRM crea automaticamente link per videoconferenze per ogni riunione. Collega Zoom, Google Meet e Zoho Meeting in modo che prospect e clienti partecipino con un clic.",
      "sections": [
        {
          "heading": "Link di riunione automatici",
          "body": "Quando qualcuno prenota una riunione tramite il tuo link FreeCRM, viene generato un link Zoom, Google Meet o Zoho Meeting e inserito automaticamente nell'invito al calendario."
        },
        {
          "heading": "Più provider",
          "body": "Usa il provider già pagato dal tuo team — Zoom, Google Meet o Zoho Meeting — o lascia che i partecipanti scelgano."
        },
        {
          "heading": "Calendario unificato",
          "body": "Dettagli della riunione, link e registrazioni restano allegati alla scheda contatto, offerta o caso, così tutto è in un unico posto."
        }
      ]
    },
    "aws": {
      "title": "FreeCRM su AWS",
      "eyebrow": "Infrastruttura",
      "description": "Disponibilità del 99,9999%, ingegneri 24/7/365 e sicurezza dei dati di livello federale su Amazon AWS.",
      "intro": "FreeCRM opera su Amazon AWS con un obiettivo di disponibilità del 99,9999%. Gli ingegneri sono in servizio 24/7/365.",
      "sections": [
        {
          "heading": "Strutture di livello federale",
          "body": "Le nostre strutture fisiche soddisfano o superano tutti i requisiti federali e internazionali per la sicurezza dei dati, la ridondanza, la ripresa e la continuità aziendale."
        },
        {
          "heading": "Cloud di altissima qualità",
          "body": "Affidati a noi per fornire i servizi cloud di altissima qualità disponibili ovunque — crittografati, monitorati e continuamente disponibili."
        }
      ]
    }
  },
  "footerPages": {
    "features": {
      "title": "Tutto ciò di cui hai bisogno in un unico CRM",
      "eyebrow": "Funzionalità",
      "description": "Chiamate, SMS, offerte, contatti, attività, casi, campagne, calendario, documenti, report, API e integrazioni integrati — gratuiti per sempre.",
      "intro": "FreeCRM ti offre contatti, aziende, offerte, attività, casi, chiamate, calendario, documenti, report, campagne, moduli, email, API e integrazioni — tutto in un unico posto, gratuito per sempre."
    },
    "pricing": {
      "title": "Prezzi",
      "description": "CRM gratuito per sempre. Pro a $10/utente/mese. Enterprise a $25/utente/mese. Numeri USA $1.15/mese, $0.01/min, $0.01/SMS."
    },
    "integrations": {
      "title": "Integrazioni e app connesse",
      "eyebrow": "Integrazioni",
      "description": "Collega FreeCRM con Google, Microsoft 365, QuickBooks, Zapier, DocuSign, WhatsApp, Zoom, Google Meet, Zoho Meeting e oltre 6.000 app.",
      "intro": "FreeCRM si connette agli strumenti che già utilizzi — Google Workspace, Microsoft 365, QuickBooks, Zapier, DocuSign, WhatsApp, Zoom, Google Meet, Zoho Meeting e migliaia di altri — per mantenere i tuoi dati sincronizzati e i tuoi flussi di lavoro automatizzati."
    },
    "changelog": {
      "title": "Novità in FreeCRM",
      "eyebrow": "Changelog",
      "description": "Miglioramenti recenti, nuove funzionalità e correzioni implementate in FreeCRM.",
      "intro": "Implementiamo miglioramenti continuamente. Ecco i punti salienti delle ultime versioni.",
      "sections": [
        {
          "heading": "Maggio 2026 — Power dialer 2.0",
          "body": "Composizione a presenza locale più veloce, segreteria telefonica intelligente e scorciatoie per la disposizione delle chiamate che riducono della metà il lavoro post-chiamata."
        },
        {
          "heading": "Aprile 2026 — Nuove app iOS e Android",
          "body": "Nuove app mobili con supporto offline, notifiche push per chiamate e SMS in entrata e accesso completo alla pipeline dal tuo telefono."
        },
        {
          "heading": "Marzo 2026 — Sincronizzazione bidirezionale QuickBooks",
          "body": "Clienti, fatture e pagamenti ora si sincronizzano bidirezionalmente tra FreeCRM e QuickBooks Online e Desktop."
        },
        {
          "heading": "Febbraio 2026 — Coaching sulle chiamate",
          "body": "Controlli di ascolto dal vivo, sussurro e inserimento per i manager, oltre a punteggi di chiamata generati dall'AI su Enterprise."
        }
      ]
    },
    "about": {
      "title": "Informazioni su FreeCRM",
      "eyebrow": "Azienda",
      "description": "Dal 2003, FreeCRM offre il primo CRM interamente gratuito al mondo, pioniere del modello freemium per team di vendita, assistenza e marketing.",
      "intro": "Perché FreeCRM è gratuito? Perché crediamo nella tua attività. Offriamo il primo CRM interamente gratuito al mondo dal 2003 — e abbiamo aiutato centinaia di migliaia di aziende a crescere.",
      "sections": [
        {
          "heading": "Perché gratis?",
          "body": "Ti offriamo un CRM gratuito come investimento in te e nella tua attività. Sappiamo che ti aiuteremo a raggiungere il successo e che, in futuro, potresti pagarci. Man mano che le tue vendite crescono, vorrai più funzionalità — e Pro ed Enterprise saranno lì quando sarai pronto."
        },
        {
          "heading": "Siamo stati pionieri del freemium",
          "body": "FreeCRM ha aperto la strada al modello freemium: software potente gratuito, con la possibilità di effettuare l'upgrade per SMS, chiamate vocali, QuickBooks, accesso API avanzato, Zapier e altro."
        },
        {
          "heading": "Costruito su AWS",
          "body": "Prendiamo sul serio la sicurezza dei dati. FreeCRM funziona su Amazon AWS con un obiettivo di disponibilità del 99,9999%. Gli ingegneri sono in servizio 24 ore su 24, 7 giorni su 7, 365 giorni l'anno, e le nostre strutture soddisfano o superano i requisiti federali e internazionali per la sicurezza dei dati, la ridondanza e la continuità."
        },
        {
          "heading": "Completo per design",
          "body": "Un CRM robusto è un'applicazione di lavoro completa che gestisce operazioni sia front-office che back-office. FreeCRM è così potente — e gratuito — coprendo vendite, assistenza, marketing, chiamate e operazioni in un unico posto."
        }
      ]
    },
    "customers": {
      "title": "I clienti adorano FreeCRM",
      "eyebrow": "Clienti",
      "description": "Scopri come i team di vendita outbound, i call center e le PMI utilizzano FreeCRM per effettuare il 40% in più di chiamate e chiudere affari più velocemente.",
      "intro": "Centinaia di migliaia di team — da startup di due persone a call center di 50 postazioni — gestiscono le vendite e l'assistenza su FreeCRM.",
      "sections": [
        {
          "heading": "Vendite interne — 40% di chiamate in più",
          "body": "\"I nostri SDR sono passati da 80 chiamate al giorno a oltre 110 una volta passati a FreeCRM. Il power dialer e il click-to-call all'interno della vista contatti hanno cambiato tutto.\" — VP di Vendite, SaaS B2B"
        },
        {
          "heading": "Call center — sostituito uno stack da $18k/anno",
          "body": "\"Abbiamo sostituito il nostro dialer, CRM e strumenti SMS con FreeCRM e risparmiato $18k all'anno — senza perdere una singola funzionalità a cui i nostri rappresentanti tenevano.\" — Direttore delle Operazioni, Assicurazioni"
        },
        {
          "heading": "PMI — migrati 50 posti",
          "body": "\"Abbiamo implementato FreeCRM per 50 agenti in due settimane. La fornitura di numeri locali e la registrazione delle chiamate erano attive dal primo giorno.\" — Responsabile delle Entrate, Servizi per la Casa"
        },
        {
          "heading": "Organizzazione senza scopo di lucro — gestione dei donatori",
          "body": "\"FreeCRM ci consente di trattare i donatori come contatti e gli impegni come trattative. Il prezzo è giusto e le funzionalità di chiamata sono un punto di svolta.\" — Direttore Esecutivo, Organizzazione senza scopo di lucro"
        }
      ]
    },
    "careers": {
      "title": "Carriere in FreeCRM",
      "eyebrow": "Carriere",
      "description": "Unisciti a un team remote-first che costruisce il CRM gratuito più popolare al mondo con chiamate e SMS integrati.",
      "intro": "Siamo un team remote-first che costruisce il CRM gratuito più popolare al mondo. Se ami il software semplice, l'iterazione veloce e i clienti che usano davvero ciò che costruisci, ci piacerebbe parlare con te.",
      "sections": [
        {
          "heading": "Come lavoriamo",
          "body": "Team piccoli, prima asincroni, prima scritti. Spediamo ogni settimana. Assumiamo senior, ci fidiamo delle persone per il loro lavoro e paghiamo in modo competitivo in contanti e azioni."
        },
        {
          "heading": "Ruoli aperti",
          "body": ""
        },
        {
          "heading": "Come candidarsi",
          "body": "Invia una email a careers@freecrm.com con il ruolo che ti interessa, una breve nota sul motivo e i link ai tuoi lavori. Rispondiamo a ogni candidatura."
        }
      ],
      "roles": [
        "Ingegnere Full-stack Senior (React / Node)",
        "Ingegnere Telefonico (WebRTC, SIP)",
        "Designer di Prodotto",
        "Successo del Cliente — Vendite Outbound",
        "Account Executive — PMI"
      ]
    },
    "contact": {
      "title": "Contatta FreeCRM",
      "eyebrow": "Contatti",
      "description": "Parla con le vendite, ottieni supporto sul prodotto o contatta i nostri team per la privacy e la sicurezza.",
      "intro": "Siamo qui per aiutarti. Contatta il team giusto qui sotto — di solito rispondiamo entro un giorno lavorativo.",
      "sections": [
        {
          "heading": "Vendite",
          "body": "Desideri una dimostrazione di Pro o Enterprise, o aiuto per il trasferimento di numeri e la migrazione da HubSpot? Invia un'email a sales@freecrm.com."
        },
        {
          "heading": "Supporto",
          "body": "Sei già cliente? Apri un ticket dall'interno dell'app o invia un'email a support@freecrm.com. I clienti Pro ed Enterprise ottengono una risposta prioritaria."
        },
        {
          "heading": "Privacy e sicurezza",
          "body": "Domande sulla privacy: privacy@freecrm.com. Divulgazioni sulla sicurezza: security@freecrm.com. Riconosciamo le segnalazioni entro 24 ore."
        },
        {
          "heading": "Indirizzo postale",
          "body": "FreeCRM, Inc. — Comunicazioni Clienti — Delaware, USA"
        }
      ]
    },
    "blog": {
      "title": "Il blog di FreeCRM",
      "eyebrow": "Blog",
      "description": "Playbook, approfondimenti sui prodotti e storie di clienti per team di vendita outbound e call center.",
      "intro": "Playbook pratici per vendite outbound, vendite interne e operazioni di call center per PMI — scritti dal team che costruisce FreeCRM.",
      "sections": [
        {
          "heading": "Come configurare un power dialer in 10 minuti",
          "body": "Una guida passo-passo per il provisioning dei numeri, l'importazione di una lista e l'esecuzione della tua prima sessione di power dialing all'interno di FreeCRM."
        },
        {
          "heading": "5 modi in cui FreeCRM batte HubSpot per le chiamate",
          "body": "Voce e SMS integrati, nessun ricarico per minuto, gratuito per sempre — le funzionalità di chiamata all'interno di FreeCRM rispetto allo Sales Hub di HubSpot."
        },
        {
          "heading": "Dai fogli di calcolo a un CRM in un pomeriggio",
          "body": "Come importare i contatti, impostare la pipeline e iniziare a tracciare le trattative su FreeCRM in un solo pomeriggio."
        },
        {
          "heading": "Costruire un call center da 50 postazioni su FreeCRM",
          "body": "Come un'azienda di servizi per la casa ha implementato FreeCRM per 50 agenti in due settimane — inclusa la fornitura di numeri locali e la registrazione delle chiamate."
        }
      ]
    },
    "help": {
      "title": "Centro assistenza",
      "eyebrow": "Risorse",
      "description": "Guide, tutorial e risposte per ottenere il massimo da FreeCRM.",
      "intro": "Cerca guide e tutorial, o sfoglia per argomento. I clienti Pro ed Enterprise ottengono anche supporto email prioritario.",
      "sections": [
        {
          "heading": "Per iniziare",
          "body": "Crea il tuo account, invita il tuo team, importa contatti e configura la tua pipeline. La maggior parte dei team è operativa in meno di un'ora."
        },
        {
          "heading": "Chiamate e SMS",
          "body": "Provisiona i numeri, configura il click-to-call, registra le chiamate, esegui il power dialer e invia SMS gratuiti da qualsiasi record di contatto."
        },
        {
          "heading": "Pipeline e trattative",
          "body": "Personalizza le fasi, crea report e previsioni e traccia ogni trattativa dal preventivo alla fattura."
        },
        {
          "heading": "Integrazioni",
          "body": "Collega Google, Microsoft 365, QuickBooks, Zapier, DocuSign, Zoom, Google Meet, Zoho Meeting e oltre 6.000 app. Sincronizza contatti, calendario, email, fatture e altro."
        },
        {
          "heading": "Amministrazione e sicurezza",
          "body": "Gestisci utenti, ruoli, SSO, log di audit ed esportazione dati. I clienti Enterprise ottengono anche il provisioning SCIM e un CSM dedicato."
        }
      ]
    },
    "apiDocs": {
      "title": "API CRM",
      "eyebrow": "Documentazione API",
      "description": "Un'API REST basata su standard per l'acquisizione di lead, la sincronizzazione dei dati e l'automazione delle vendite inbound e del supporto all'interno di FreeCRM.",
      "intro": "Ottieni il massimo dal tuo CRM e automatizza le vendite inbound e il servizio clienti. I nostri servizi web API consentono al tuo sito web di inviare e ricevere dati direttamente in FreeCRM.",
      "whatHeading": "Cosa puoi fare",
      "capturesHeading": "Cattura lead dal sito web",
      "authHeading": "Autenticazione",
      "webhooksHeading": "Webhook",
      "rateLimitsHeading": "Limiti di velocità e SDK",
      "sections": [
        {
          "heading": "Cosa puoi fare",
          "body": "Collega moduli web, instrada email in entrata, apri casi di supporto, acquisisci lead e sincronizza dati con qualsiasi sistema esterno. Utilizziamo un'API REST basata su standard, facile da integrare da qualsiasi tecnologia."
        },
        {
          "heading": "Cattura lead dal sito web",
          "body": "Aggiungi il nostro modello di codice a qualsiasi modulo web e inizia a catturare lead di assistenza clienti e vendite in tempo reale, direttamente all'interno di FreeCRM. Riduci il rumore delle email in entrata e non perdere mai un lead."
        },
        {
          "heading": "Webhook",
          "body": "Iscriviti agli eventi — contact.created, deal.updated, call.completed, sms.received — e inviali ai tuoi sistemi in tempo reale."
        },
        {
          "heading": "Limiti di velocità e SDK",
          "body": "1.000 richieste/minuto su Pro, 5.000/minuto su Enterprise. Sono disponibili SDK ufficiali per Node e Python; le librerie della comunità coprono Ruby, PHP e Go."
        }
      ]
    },
    "community": {
      "title": "Comunità FreeCRM",
      "eyebrow": "Comunità",
      "description": "Connettiti con migliaia di utenti FreeCRM, condividi playbook e ottieni risposte dal team.",
      "intro": "Unisciti a migliaia di utenti FreeCRM che condividono playbook, automazioni e best practice per le vendite outbound e le operazioni di call center.",
      "sections": [
        {
          "heading": "Forum",
          "body": "Fai domande, condividi ciò che funziona e impara dai team che gestiscono FreeCRM a ogni livello — da fondatori singoli a call center da 50 postazioni."
        },
        {
          "heading": "Slack e Discord",
          "body": "Canali in tempo reale per utenti esperti, amministratori e sviluppatori che costruiscono sull'API di FreeCRM. Anche il team di prodotto è presente."
        },
        {
          "heading": "Orari d'ufficio",
          "body": "Sessioni live settimanali che coprono onboarding, power dialing, integrazioni e nuove funzionalità. Gratuite per tutti i clienti."
        }
      ]
    },
    "privacy": {
      "title": "Informativa sulla privacy",
      "eyebrow": "Legale",
      "description": "Informativa sulla privacy di FreeCRM: i tuoi dati sono sempre privati e non vengono mai condivisi con terze parti.",
      "intro": "I tuoi dati sono sempre privati. Non condividiamo i dati dei clienti con terze parti.",
      "sections": [
        {
          "heading": "Raccolta e utilizzo delle informazioni",
          "body": "I tuoi dati sono al 100% privati. Non utilizziamo i dati che inserisci nel sistema per nessun altro scopo se non quello di supportare il tuo CRM. I dati che inserisci rimarranno di esclusiva proprietà degli individui e delle organizzazioni che li hanno inseriti. Questi dati non vengono mai condivisi con organizzazioni esterne o terze parti. In caso di acquisizione, insolvenza, cambio di proprietà o qualsiasi modifica nella struttura aziendale, garantiremo sempre che i tuoi dati rimangano privati e non compromessi."
        },
        {
          "heading": "Cosa raccogliamo",
          "body": "Raccogliamo le informazioni di identificazione personale necessarie per fornire il servizio: nome, email, telefono, dettagli di fatturazione e i dati che scegli di archiviare all'interno del tuo CRM. Raccogliamo dati di registro e utilizzo per operare, proteggere e migliorare il servizio."
        },
        {
          "heading": "Come utilizziamo le informazioni",
          "body": "Utilizziamo le informazioni per fornire e migliorare il servizio, comunicare con te, fornire supporto, proteggere la piattaforma e rispettare gli obblighi legali. Non vendiamo mai dati personali."
        },
        {
          "heading": "Condivisione",
          "body": "Non condividiamo né vendiamo informazioni sugli utenti. Coinvolgiamo sub-responsabili del trattamento di fiducia (come i nostri fornitori di cloud e telefonia) rigorosamente per operare il servizio, in base a contratti che richiedono riservatezza e protezione dei dati."
        },
        {
          "heading": "Scelte e correzioni",
          "body": "Puoi accedere, correggere, esportare o eliminare i tuoi dati in qualsiasi momento dall'interno dell'app o contattando privacy@freecrm.com."
        },
        {
          "heading": "Sicurezza",
          "body": "FreeCRM opera su Amazon AWS con controlli di sicurezza fisici, di rete e applicativi standard del settore, crittografia in transito e a riposo e monitoraggio 24/7/365."
        },
        {
          "heading": "Contatti",
          "body": "Domande o dubbi? Invia una email a privacy@freecrm.com. Risponderemo entro un periodo di tempo ragionevole."
        }
      ]
    },
    "terms": {
      "title": "Termini di servizio",
      "eyebrow": "Legale",
      "description": "Il Contratto di Sottoscrizione che regola l'utilizzo del software e dei servizi FreeCRM.",
      "intro": "Utilizzando il software FreeCRM, l'utente accetta, per conto dell'entità che licenzia il software, di essere vincolato dal presente Accordo di Sottoscrizione.",
      "sections": [
        {
          "heading": "1. Accettazione",
          "body": "Cliccando su \"Accetto\" o utilizzando il software FreeCRM selezionato, accetti per conto dell'entità che licenzia il software (\"Azienda\") che l'Azienda sta diventando parte di questo Accordo e che hai l'autorità di vincolare l'Azienda. Se l'Azienda non è d'accordo, non registrarti o utilizzare il software."
        },
        {
          "heading": "2. Descrizione del servizio",
          "body": "FreeCRM fornisce il suo servizio soggetto a questi Termini di servizio, che possono essere aggiornati da noi di volta in volta. La versione corrente è sempre pubblicata a questo URL. Particolari funzionalità possono essere soggette a linee guida aggiuntive pubblicate, che sono incorporate per riferimento."
        },
        {
          "heading": "3. Il tuo account",
          "body": "Sei responsabile di mantenere la riservatezza delle tue credenziali e di tutte le attività che si verificano sotto il tuo account. Notificaci immediatamente qualsiasi uso non autorizzato."
        },
        {
          "heading": "4. Uso accettabile",
          "body": "Accetti di non utilizzare FreeCRM per inviare spam, molestare altri, violare la proprietà intellettuale, distribuire malware o violare qualsiasi legge applicabile. Possiamo sospendere gli account che violano queste regole."
        },
        {
          "heading": "5. Commissioni",
          "body": "Il piano Free è offerto gratuitamente. I piani Pro ed Enterprise sono fatturati in anticipo su base mensile o annuale. L'utilizzo della telefonia (numeri, minuti, SMS) è fatturato secondo le tariffe pubblicate."
        },
        {
          "heading": "6. Proprietà dei dati",
          "body": "Conservi tutti i diritti sui dati che inserisci in FreeCRM. Li elaboriamo esclusivamente per fornire e migliorare il servizio."
        },
        {
          "heading": "7. Risoluzione",
          "body": "Entrambe le parti possono risolvere in qualsiasi momento. Alla risoluzione puoi esportare i tuoi dati; dopo un periodo ragionevole potremmo eliminarli."
        },
        {
          "heading": "8. Esclusioni di responsabilità e limitazione di responsabilità",
          "body": "Il servizio è fornito \"così com'è\" senza garanzie di alcun tipo. Nella massima misura consentita dalla legge, la responsabilità complessiva di FreeCRM è limitata alle commissioni pagate nei dodici mesi precedenti la richiesta."
        },
        {
          "heading": "9. Legge applicabile",
          "body": "Questo Accordo è regolato dalle leggi dello Stato del Delaware, USA, senza riguardo ai principi di conflitto di leggi."
        }
      ]
    },
    "security": {
      "title": "Sicurezza",
      "eyebrow": "Fiducia",
      "description": "Come FreeCRM mantiene i tuoi dati al sicuro — basato su Amazon AWS con crittografia, monitoraggio 24/7 e controlli di accesso rigorosi.",
      "intro": "Prendiamo sul serio la sicurezza dei dati. FreeCRM opera su Amazon AWS con un obiettivo di disponibilità del 99,9999% e ingegneri in servizio 24 ore su 24, 7 giorni su 7, 365 giorni l'anno.",
      "sections": [
        {
          "heading": "Infrastruttura",
          "body": "FreeCRM funziona su Amazon AWS. Le nostre strutture fisiche soddisfano o superano tutti i requisiti federali e internazionali per la sicurezza dei dati, la ridondanza, la ripresa e la continuità aziendale."
        },
        {
          "heading": "Crittografia",
          "body": "Tutti i dati sono crittografati in transito utilizzando TLS 1.2+ e a riposo utilizzando AES-256. I backup sono crittografati e archiviati su più zone di disponibilità."
        },
        {
          "heading": "Controlli di accesso",
          "body": "Accesso basato sui ruoli all'interno dell'applicazione, principio del privilegio minimo per l'accesso alla produzione e registrazione di audit delle azioni amministrative. I clienti Enterprise ottengono SSO (SAML), provisioning SCIM e log di audit completi."
        },
        {
          "heading": "Monitoraggio e risposta",
          "body": "Monitoraggio 24/7/365 della piattaforma, avvisi automatici e un team di ingegneri di guardia. Testiamo regolarmente i backup ed eseguiamo esercizi periodici di risposta agli incidenti."
        },
        {
          "heading": "Segnalazione di una vulnerabilità",
          "body": "Invia un'e-mail a security@freecrm.com con i dettagli. Riconosciamo i rapporti entro 24 ore e accreditiamo la divulgazione responsabile."
        }
      ]
    },
    "dpa": {
      "title": "Addendum per il trattamento dei dati",
      "eyebrow": "Legale",
      "description": "Il DPA disciplina il modo in cui FreeCRM elabora i dati personali per conto dei clienti, in conformità con il GDPR e leggi simili.",
      "intro": "Questo Addendum per il trattamento dei dati (DPA) integra il tuo Contratto di sottoscrizione FreeCRM e disciplina il modo in cui elaboriamo i dati personali per tuo conto.",
      "sections": [
        {
          "heading": "1. Ruoli",
          "body": "Tu (Cliente) sei il titolare del trattamento dei dati. FreeCRM agisce come responsabile del trattamento e elabora i dati personali solo su tue istruzioni documentate, inclusi i trasferimenti, tranne dove richiesto dalla legge applicabile."
        },
        {
          "heading": "2. Oggetto e durata",
          "body": "Oggetto: fornitura del servizio FreeCRM. Durata: la durata del Contratto più qualsiasi periodo di conservazione post-risoluzione."
        },
        {
          "heading": "3. Sub-responsabili",
          "body": "Coinvolgiamo sub-responsabili del trattamento controllati (incluso AWS per l'hosting e i nostri fornitori di telefonia per voce e SMS). Un elenco aggiornato è disponibile su richiesta. Notifichiamo i clienti di modifiche materiali."
        },
        {
          "heading": "4. Misure di sicurezza",
          "body": "Implementiamo misure tecniche e organizzative appropriate al rischio, inclusa la crittografia in transito e a riposo, controlli di accesso, logging, gestione delle vulnerabilità e formazione del personale."
        },
        {
          "heading": "5. Diritti degli interessati",
          "body": "Ti assistiamo nell'adempiere alle richieste degli interessati (accesso, rettifica, cancellazione, portabilità) tramite strumenti in-app e, se necessario, supporto."
        },
        {
          "heading": "6. Trasferimenti internazionali",
          "body": "Laddove i dati personali vengano trasferiti al di fuori dell'EEA, del Regno Unito o della Svizzera, il trasferimento è regolato da clausole contrattuali standard o altro meccanismo di trasferimento legittimo."
        },
        {
          "heading": "7. Notifica di violazione",
          "body": "Ti avviseremo senza indebito ritardo dopo essere venuti a conoscenza di una violazione dei dati personali che interessa i tuoi dati."
        },
        {
          "heading": "8. Audit",
          "body": "Previa ragionevole preavviso, renderemo disponibili le informazioni necessarie per dimostrare la conformità, inclusi i rapporti di audit di terze parti ove applicabile."
        }
      ]
    },
    "industriesIndex": {
      "title": "FreeCRM per settore",
      "eyebrow": "Settori",
      "description": "Scopri come i team di call center, assicurazioni, immobiliare, odontoiatria, servizi professionali e altri utilizzano FreeCRM.",
      "intro": "Modelli e flussi di lavoro per i settori che operano con FreeCRM."
    }
  }
};

export default it;
